import React from 'react';

const tips = [
  "💡 Always set a stop loss before entering a trade.",
  "💰 Delivering quality work consistently earns client trust — and repeat jobs.",
  "📊 Diversify your investment to reduce risk.",
  "🛠️ Build your personal brand. It’s your digital resume.",
  "📈 Analyze RSI and volume before breakout confirmation.",
];

export default function AITipBox() {
  // Select a random tip on render
  const todayTip = tips[Math.floor(Math.random() * tips.length)];

  return (
    <div className="bg-black border-l-4 border-indigo-500 text-indigo-800 p-4 rounded-lg mb-6">
      <h3 className="font-semibold text-sm mb-1">🤖 AI Tip of the Day</h3>
      <p className="text-sm">{todayTip}</p>
    </div>
  );
}
